var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"6","y":"9","width":"20","height":"2","rx":"1","fill":"currentColor","key":0}),React.createElement("rect",{"x":"6","y":"15","width":"20","height":"2","rx":"1","fill":"currentColor","key":1}),React.createElement("rect",{"x":"6","y":"21","width":"20","height":"2","rx":"1","fill":"currentColor","key":2})]);
}

Menu.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 32 32","fill":"none"};

module.exports = Menu;

Menu.default = Menu;
